import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/5c0e3d34-08be-4b17-a131-b8f0a221f6bb";
export const REGISTER_URL = "https://a.ntrk2.com/aa3cf7d3-4c68-4caa-8c4d-351960e0a61b";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://gocashpk.kzw2a.com/download?openExternalBrowser=1&id=1vwvve259aqunun";

export * from "./codes";
export * from "./context";
